export default {"src":"/_next/static/media/download-dark-gray.44fffa51.svg","height":16,"width":14};